/*
 * Purpose: Mission vs Flow lifecycle — running Mission, validated Flow at rest
 * Last modified: 2026-06-27 | Agent
 * Completeness: 100
 */

/** Running = Mission; at rest after approve = Flow */
export type ArtifactState = 'mission' | 'flow';

/** How a running Mission is executed in compose */
export type ComposeMode = 'express' | 'guided';

export type MissionStepKind =
  | 'capture'
  | 'interpret'
  | 'confirm'
  | 'mode_switch'
  | 'plan'
  | 'dry_run'
  | 'approve'
  | 'blocker'
  | 'express';

export interface MissionStep {
  id: string;
  at: string;
  label: string;
  kind: MissionStepKind;
  detail?: string;
}

export function createMissionStep(
  kind: MissionStepKind,
  label: string,
  detail?: string
): MissionStep {
  return {
    id: `ms-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
    at: new Date().toISOString(),
    kind,
    label,
    detail,
  };
}
